<script lang="ts" setup>
import SubscribePageVowpath from './components/SubscribePage.vowpath.vue'
import { getSubscribePageConfig } from '@/composables/payment'

const config = getSubscribePageConfig()
const SubscribePage = SubscribePageVowpath
</script>

<template>
  <div>
    <!-- 品牌专属页面组件 -->
    <SubscribePage :config="config" />
  </div>
</template>
